import { api } from '../../../shared/services/api/client';

export const createLoyaltyClass = (programName, logoUrl, brandColor, textColor) => {
    // Class id is derived from authenticated merchant DB id; issuer display name comes from the merchant row.
    return api.post('/passes/google/classes/create', {
        programName,
        logoUrl,
        platform: 'android',
        ...(brandColor !== null && { brandColor }),
        ...(textColor !== null && { textColor }),
    });
};

export const createGooglePassWithQR = async (
    email,
    phone_number,
    name,
    birthDate,
    platform,
    optInMarketing,
    merchantId = null
) => {
    const payload = {
        email,
        phone_number,
        name,
        birthDate,
        platform: 'android', // Always android for Google Wallet
        optInMarketing,
    };
    if (merchantId) {
        payload.merchantId = merchantId;
    }
    // Using versioned API endpoint
    return api.post('/passes/create', payload);
};

export const createGooglePassWithLink = async (
    email,
    phone_number,
    name,
    birthDate,
    platform,
    optInMarketing,
    signupToken
) => {
    const payload = {
        email,
        phone_number,
        name,
        birthDate,
        platform: 'android', // Always android for Google Wallet
        optInMarketing,
        signupToken,
    };
    // Using versioned API endpoint
    return api.post('/passes/create-with-link', payload);
};
